import React, { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import qs from 'qs';

import guideIcon from '../../../icons/ic-qmark-orange.png';
import GuideModal from '../../../components/GuideModal';

import '../../../index.css';
import SelectBox from '../../../components/SelectBox';

import { getShopList, getShopToken } from '../../../modules/NetworkFunction';

function ShopLink(props) {
  const { shopVersion, multiShopSelected, setMakeShop } = props;

  const [isHovered, setIsHovered] = useState(false);

  const cafe24MallIdInputRef = useRef(null);

  const [multiShopList, setMultiShopList] = useState([]);

  const [makeShopData, setMakeShopData] = useState({
    url: '',
    shopKey: '',
  });

  const cafe24SelectBoxRef = useRef(null);
  const [selectedCafe24Shop, setSelectedCafe24Shop] = useState();

  const query = window.location.search;
  const params = new URLSearchParams(query);
  const cafe24AuthCode = params.get('code');

  const handleLinkMakeshop = (e) => {
    const { name, value } = e.target;
    setMakeShopData((prev) => {
      setMakeShop({
        ...prev,
        [name]: value,
      });

      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleLinkCafe24 = async () => {
    const mallId = cafe24MallIdInputRef.current.value;
    if (!mallId) {
      alert('쇼핑몰 아이디를 입력해 주세요.');
      return;
    }
    try {
      await fetch(`https://${mallId}.cafe24api.com/api/v2/admin`);
      sessionStorage.setItem('mallId', mallId);
      localStorage.setItem('mallId', mallId);

      const authQuery = qs.stringify({
        response_type: 'code',
        client_id: process.env.REACT_APP_CAFE24_CLIENT_ID,
        state: 'authcode',
        redirect_uri: window.location.origin + window.location.pathname,
        scope:
          'mall.read_product,mall.write_product,mall.read_store,mall.write_application,mall.read_application,mall.read_design,mall.read_category,mall.write_category',
      });

      const loginUrl = `https://${mallId}.cafe24api.com/api/v2/oauth/authorize?${authQuery}`;

      window.location.assign(loginUrl);
    } catch (e) {
      console.log(e);
      alert('존재하지 않는 쇼핑몰입니다. 다시 시도해주세요.');
    }
  };

  useEffect(() => {
    if (cafe24AuthCode) {
      getShopToken(
        {
          code: cafe24AuthCode,
          mallId: cafe24MallIdInputRef.current.value,
          redirectURI: window.location.origin + window.location.pathname,
        },
        (data) => {
          sessionStorage.setItem('accessToken', data.access_token);
          sessionStorage.setItem('refreshToken', data.refresh_token);
          sessionStorage.setItem('expiredTime', data.expires_at);
          sessionStorage.setItem(
            'refreshTokenExpiredTime',
            data.refresh_token_expires_at
          );
          sessionStorage.setItem('modalOpen', 'true');
          getShopList(
            {
              mallId: sessionStorage.getItem('mallId'),
              token: data.access_token,
            },
            (shopList) => {
              setMultiShopList(shopList);
            },
            (e) => {
              console.log(e);
            }
          );
        },
        () => {},
        (e) => {
          alert('연동에 실패했습니다. 다시 시도해주세요.');
        },
        null
      );
    }
  }, [cafe24AuthCode]);

  return (
    <div>
      {shopVersion === 'cafe24' ? (
        <div
          style={{ display: 'flex', flexDirection: 'column', marginTop: 0 }}
          className="inner-box"
        >
          <Cafe24InputTitle>쇼핑몰 아이디를 입력해 주세요</Cafe24InputTitle>
          <Cafe24IdInputContainer>
            <input
              ref={cafe24MallIdInputRef}
              type="text"
              name="cafe24MallId"
              defaultValue={sessionStorage.getItem('mallId') || ''}
              style={{ width: 375, height: 38, borderColor: '#ccc' }}
            />
            <LinkButton onClick={handleLinkCafe24}>연동하기</LinkButton>
          </Cafe24IdInputContainer>
          <NoticeText>
            * 아이디 입력 후, 멀티 쇼핑몰 선택이 가능합니다.
          </NoticeText>
          {cafe24AuthCode && (
            <InputContainer>
              <FlexContainer>
                <Cafe24SelectTitle>
                  관리할 쇼핑몰을 선택해 주세요.
                </Cafe24SelectTitle>
                {selectedCafe24Shop && (
                  <ModifyButton
                    onClick={() => {
                      cafe24SelectBoxRef.current.handleOpen();
                    }}
                  >
                    수정
                  </ModifyButton>
                )}
              </FlexContainer>
              <SelectBox
                ref={cafe24SelectBoxRef}
                width={470}
                options={multiShopList.map((shop) => shop.shop_name)}
                onSelect={(option) => {
                  const selectedShop = multiShopList.find(
                    (shop) => shop.shop_name === option
                  );
                  multiShopSelected(selectedShop); // 부모 컴포넌트의 함수 호출
                  setSelectedCafe24Shop(selectedShop);
                }}
              />
            </InputContainer>
          )}
        </div>
      ) : (
        <div
          style={{ display: 'flex', flexDirection: 'column', marginTop: 10 }}
          className="inner-box"
        >
          <Cafe24InputTitle>쇼핑몰 URL을 입력해 주세요</Cafe24InputTitle>

          <Input
            type="text"
            name="url"
            width={470}
            value={makeShopData.url}
            onChange={handleLinkMakeshop}
            onPaste={handleLinkMakeshop}
            placeholder={'http://'}
          />
          <MakeShopInputTitleContainer>
            <MakeShopInputTitle>
              쇼핑몰 상점키를 입력해 주세요
            </MakeShopInputTitle>
            <GuideButton
              shopMode={'makeshop'}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <img src={guideIcon} alt="가이드 보기 버튼" width={20} />
              <GuideText isHovered={isHovered}>메이크샵 가이드</GuideText>
              {isHovered && (
                <GuideModal
                  videoLink=""
                  pdfLink="https://wizmon-bucket.s3.ap-northeast-2.amazonaws.com/guides/%E1%84%86%E1%85%A6%E1%84%8B%E1%85%B5%E1%84%8F%E1%85%B3%E1%84%89%E1%85%A3%E1%86%B8_%E1%84%89%E1%85%A1%E1%86%BC%E1%84%8C%E1%85%A5%E1%86%B7%E1%84%8F%E1%85%B5+%E1%84%87%E1%85%A9%E1%86%A8%E1%84%89%E1%85%A1%E1%84%80%E1%85%A1%E1%84%8B%E1%85%B5%E1%84%83%E1%85%B3.pdf"
                  style={{ marginLeft: '90px' }}
                />
              )}
            </GuideButton>
          </MakeShopInputTitleContainer>
          <Input
            type="text"
            name="shopKey"
            value={makeShopData.shopKey}
            width={470}
            onPaste={handleLinkMakeshop}
            onChange={handleLinkMakeshop}
          />
        </div>
      )}
    </div>
  );
}

export default ShopLink;

const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 32px;
  margin-bottom: 16px;
  justify-content: space-between;
`;

const InputContainer = styled.div`
  margin-bottom: 10px;
`;

const ModifyButton = styled.button`
  font-size: 14px;
  cursor: pointer;
  color: #b5b5b5;
  border: none;
  background-color: transparent;
  text-decoration: underline;
  text-underline-position: under;
`;

const Cafe24IdInputContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 18px 0px 14px 0px;
  text-align: center;
`;

const LinkButton = styled.div`
  width: 83px;
  height: 38px;
  padding: 7px 12px 8px 12px;
  margin-left: 12px;
  text-align: center;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 500;
  border-width: 0;
  background-color: #b5b5b5;
  color: #fff;
  cursor: pointer;
`;

const Cafe24InputTitle = styled.div`
  margin-top: 32px;
  font-size: 18px;
  font-weight: 400;
`;

const MakeShopInputTitle = styled.div`
  font-size: 18px;
  font-weight: 400;
`;

const MakeShopInputTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 32px;
`;

const GuideButton = styled.button`
  position: relative;
  border: none;
  background-color: transparent;
  color: #ff7a00;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

const GuideText = styled.p`
  color: #ff7a00;
  font-size: 14px;
  cursor: pointer;
  text-decoration: ${(props) => (props.isHovered ? 'underline' : 'none')};
  line-height: ${(props) => (props.isHovered ? 'normal' : 'initial')};
  text-underline-position: under;
`;

const Cafe24SelectTitle = styled.div`
  font-size: 18px;
  font-weight: 400;
`;

const Input = styled.input`
  height: 38px;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding-left: 12px;
  font-size: 18px;
  margin-top: 16px;
  width: ${({ width }) => width}px;
`;

const NoticeText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #848484;
`;
